export const PRE_ELIGIBILITY_FUNNEL_NAME = "preEligibility";
